<template>
    <div class="wrapper-bids-lists">
        <div class="tabs" v-if="sortProgressBids.length || sortconfirmedAndCompletedBids.length || sortcancelBids.length">

            <div class="row wrapper-table-title">
                <div class="col-12 col-lg-4 col-xxl-3 mb-3 tab-title" v-bind:class="{active: firstList}">
                    <a class="cursor-pointer js-change-tab" @click="selectFirstList()">
                        In Progress ({{ sortProgressBids.length }})
                    </a>
                </div>
                <div class="col-12 col-lg-3 col-xxl-3 mb-3 tab-title" v-bind:class="{active: secondList}">
                    <a class="js-change-tab cursor-pointer" @click="selectSecondList()">
                        Confirmed ({{ sortconfirmedAndCompletedBids.length }})
                    </a>
                </div>
                <div class="col-12 col-lg-4 col-xxl-4 mb-3 tab-title" v-bind:class="{active: thirdList}">
                    <a class="js-change-tab cursor-pointer" @click="selectThirdList()">
                        Cancelled ({{ sortcancelBids.length }})
                    </a>
                </div>
            </div>
            <!--First List New and Process-->
            <div v-if="firstList">
                <div class="accordion accordion-flush" v-if="sortProgressBids.length" id="accordion-flash">
                    <div class="accordion-item" v-for="(bid, index) in sortProgressBids" :key="index">
                        <div class="header-venue-accordion row">
                            <div class="col-12 col-sm-7 col-lg-5 col-xl-4">
                                <p class="big-text mb-0">{{ bid.start_date }}</p>
                                <p class="main-text">Start Date</p>
                            </div>

                            <div class="col-12 col-sm-5 col-lg-3 col-xl-4">
                                <p class="big-text mb-0">${{ bid.budget }}</p>
                                <p class="main-text">Your Rate</p>
                            </div>

                            <div class="col-12 col-lg-4 col-xl-4 align-self-center">
                                <div class="row">
                                    <div class="col-7 col-xl-5 main-text text-center"
                                         v-bind:class="{'new' : bid.status === 0}">
                                        <span class="status-bags">{{ getStatus(bid.status) }}</span>
                                    </div>
                                    <div class="col-2 col-xl-5 d-flex justify-content-center">
                                        <a @click="editBid(bid)" class="cursor-pointer">
                                            <img :src="getPhoto() + 'edit.png'" alt="Edit">
                                        </a>
                                    </div>
                                    <div class="col-2">
                                        <button class="accordion-button collapsed" type="button"
                                                data-bs-toggle="collapse"
                                                :data-bs-target="'#flush-collapse-' + bid.id">
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div :id="'flush-collapse-' + bid.id" class="accordion-collapse collapse"
                             data-bs-parent="#accordion-flash">
                            <div class="accordion-body">
                                <div class="row mb-5">
                                    <div class="mb-4 mb-md-0 col-12 col-md-5 col-lg-4">
                                        <p class="main-text-bold">Sound</p>
                                        <div class="d-flex wrapper-keywords-pills">
                                            <div class="keywords-pills mb-2"
                                                 v-for="(keyword, index) in bid.array_keywords"
                                                 :key="index">{{ keyword }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mb-4 mb-md-0 col-12 col-md-7 col-lg-8">
                                        <p class="main-text-bold">End Date</p>
                                        <p class="big-text">{{ bid.end_date }}</p>
                                    </div>
                                </div>
                                <div class="row mb-4">
                                    <div class="col-12 col-md-6 col-lg-4 mt-4">
                                        <p class="main-text-bold">Sound Equipment</p>
                                        <p class="main-text">
                                            <span v-if="bid.bring_equipment">Artist must bring own sound equipment</span>
                                            <span v-else>Artist mustn't bring own sound equipment</span>
                                        </p>
                                    </div>
                                    <div class="col-12 col-md-6 col-lg-8 mt-4">
                                        <p class="main-text-bold">Special Riders/Extras</p>
                                        <p class="main-text">{{ bid.riders ? bid.riders : '-' }}</p>
                                    </div>

                                </div>
                                <div class="row mb-4">
                                    <div class="col-12 col-md-6 col-lg-4 mt-4">
                                        <p class="big-artist-text mb-1">{{ bid.start_time }}</p>
                                        <p class="main-text">Start Time</p>
                                    </div>
                                    <div class="col-12 col-md-6 col-lg-4 mt-4">
                                        <p class="big-artist-text mb-1">{{ bid.duration }} hr</p>
                                        <p class="main-text">Duration</p>
                                    </div>
                                    <div class="col-12 col-md-6 col-lg-4 mt-4">
                                        <p class="big-artist-text mb-1">{{ bid.venue.venue_info.capacity }}</p>
                                        <p class="main-text">Venue Capacity</p>
                                    </div>
                                </div>
                                <div class="row justify-content-end cancel">
                                    <div class="col-5 col-lg-3 col-xxl-2 text-end">
                                        <a @click="cancelBid(bid)" class="cursor-pointer">
                                            <img :src="getPhoto() + 'trash.png'" alt="Cancel">
                                            <span>Cancel Bid</span>
                                        </a>
                                    </div>
                                </div>
                                <div class="row" v-if="bid.status === 1">
                                    <vue-artists-info :bid="bid"></vue-artists-info>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="empty-records" v-else>
                    <h3>You do not have any current bids in progress. Create a new bid <a :href="bidCreateUrl">
                        here
                    </a>
                        .</h3>
                </div>
            </div>

            <!--Second List Booking-->
            <div v-else-if="secondList">
                <div class="accordion accordion-flush" v-if="sortconfirmedAndCompletedBids.length"
                     id="confirmed-accordion-flash">
                    <div class="accordion-item" v-for="(bid, index) in sortconfirmedAndCompletedBids" :key="index">
                        <div class="header-venue-accordion row">
                            <div class="col-12 col-sm-7 col-lg-5 col-xl-5">
                                <p class="big-text mb-0">{{ bid.start_date }}</p>
                                <p class="main-text">Start Date</p>
                            </div>

                            <div class="col-12 col-sm-5 col-lg-3">
                                <p class="big-text mb-0">${{ bid.budget }}</p>
                                <p class="main-text">Your Rate</p>
                            </div>

                            <div class="col-12 сol-sm-3 col-lg-3 col-xl-4 align-self-center">
                                <div class="row">
                                    <div class="col-8 col-lg-9 col-xl-7 main-text text-center p-0">
                                        <span class="status-bags">{{ getStatus(bid.status) }}</span>
                                    </div>
                                    <div class="col-1 col-lg-1 col-xl-2 col-xxl-3">

                                    </div>
                                    <div class="col-2 col-lg-1 col-xl-2">
                                        <button class="accordion-button collapsed" type="button"
                                                data-bs-toggle="collapse"
                                                :data-bs-target="'#flush-collapse-' + bid.id">
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div :id="'flush-collapse-' + bid.id" class="accordion-collapse collapse"
                             data-bs-parent="#confirmed-accordion-flash">
                            <div class="accordion-body">
                                <div class="row justify-content-end">
                                    <div class="col-5 text-end">
                                        <button class="btn-apply button-text" @click="openBookingPage(bid)"
                                                type="button">
                                            Open Booking
                                        </button>
                                    </div>
                                </div>
                                <div class="row mb-5">
                                    <div class="mb-4 mb-md-0 col-12 col-md-5 col-lg-4">
                                        <p class="main-text-bold">Sound</p>
                                        <div class="d-flex wrapper-keywords-pills">
                                            <div class="keywords-pills mb-2"
                                                 v-for="(keyword, index) in bid.array_keywords"
                                                 :key="index">{{ keyword }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mb-4 mb-md-0 col-12 col-md-7 col-lg-8">
                                        <p class="main-text-bold">End Date</p>
                                        <p class="big-text">{{ bid.end_date }}</p>
                                    </div>
                                </div>
                                <div class="row mb-4">
                                    <div class="col-12 col-md-6 col-lg-4 mt-4">
                                        <p class="main-text-bold">Sound Equipment</p>
                                        <p class="main-text">
                                            <span v-if="bid.bring_equipment">Artist must bring own sound equipment</span>
                                            <span v-else>Artist mustn't bring own sound equipment</span>
                                        </p>
                                    </div>
                                    <div class="col-12 col-md-6 col-lg-8 mt-4">
                                        <p class="main-text-bold">Special Riders/Extras</p>
                                        <p class="main-text">{{ bid.riders ? bid.riders : '-' }}</p>
                                    </div>

                                </div>
                                <div class="row mb-4">
                                    <div class="col-12 col-md-6 col-lg-4 mt-4">
                                        <p class="big-artist-text mb-1">{{ bid.start_time }}</p>
                                        <p class="main-text">Start Time</p>
                                    </div>
                                    <div class="col-12 col-md-6 col-lg-4 mt-4">
                                        <p class="big-artist-text mb-1">{{ bid.duration }} hr</p>
                                        <p class="main-text">Duration</p>
                                    </div>
                                    <div class="col-12 col-md-6 col-lg-4 mt-4">
                                        <p class="big-artist-text mb-1">{{ bid.venue.venue_info.capacity }}</p>
                                        <p class="main-text">Venue Capacity</p>
                                    </div>
                                </div>
                                <div class="row" v-if="bid.status === 2 || bid.status === 3 || bid.status === 4">
                                    <vue-artist-info :bid="bid"></vue-artist-info>
                                    <vue-all-artists-info :bid="bid"></vue-all-artists-info>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="empty-records" v-else>
                    <h3>No confirmed bids at the moment. As soon as you confirm an artist for a bid, they will show up here.</h3>
                </div>
            </div>

            <!--Third List Canceled-->
            <div v-else>
                <div class="accordion accordion-flush" v-if="sortcancelBids.length" id="confirmed-accordion-flash">
                    <div class="accordion-item" v-for="(bid, index) in sortcancelBids" :key="index">
                        <div class="header-venue-accordion row">
                            <div class="col-12 col-sm-7 col-lg-5 col-xl-4">
                                <p class="big-text mb-0">{{ bid.start_date }}</p>
                                <p class="main-text">Start Date</p>
                            </div>

                            <div class="col-12 col-sm-5 col-lg-4">
                                <p class="big-text mb-0">${{ bid.budget }}</p>
                                <p class="main-text">You Rate</p>
                            </div>

                            <div class="col-12 col-lg-3 col-xl-4 align-self-center">
                                <div class="row">
                                    <div class="col-5 main-text text-center">
                                        <span class="status-bags">{{ getStatus(bid.status) }}</span>
                                    </div>
                                    <div class="col-5">

                                    </div>
                                    <div class="col-2">
                                        <button class="accordion-button collapsed" type="button"
                                                data-bs-toggle="collapse"
                                                :data-bs-target="'#flush-collapse-' + bid.id">
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div :id="'flush-collapse-' + bid.id" class="accordion-collapse collapse"
                             data-bs-parent="#confirmed-accordion-flash">
                            <div class="accordion-body">
                                <div class="row mb-5">
                                    <div class="mb-4 mb-md-0 col-12 col-md-5 col-lg-4">
                                        <p class="main-text-bold">Sound</p>
                                        <div class="d-flex wrapper-keywords-pills">
                                            <div class="keywords-pills mb-2"
                                                 v-for="(keyword, index) in bid.array_keywords"
                                                 :key="index">{{ keyword }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mb-4 mb-md-0 col-12 col-md-7 col-lg-8">
                                        <p class="main-text-bold">End Date</p>
                                        <p class="big-text">{{ bid.end_date }}</p>
                                    </div>
                                </div>
                                <div class="row mb-4">
                                    <div class="col-12 col-md-6 col-lg-4 mt-4">
                                        <p class="main-text-bold">Sound Equipment</p>
                                        <p class="main-text">
                                            <span v-if="bid.bring_equipment">Artist must bring own sound equipment</span>
                                            <span v-else>Artist mustn't bring own sound equipment</span>
                                        </p>
                                    </div>
                                    <div class="col-12 col-md-6 col-lg-8 mt-4">
                                        <p class="main-text-bold">Special Riders/Extras</p>
                                        <p class="main-text">{{ bid.riders ? bid.riders : '-' }}</p>
                                    </div>

                                </div>
                                <div class="row mb-4">
                                    <div class="col-12 col-md-6 col-lg-4 mt-4">
                                        <p class="big-artist-text mb-1">{{ bid.start_time }}</p>
                                        <p class="main-text">Start Time</p>
                                    </div>
                                    <div class="col-12 col-md-6 col-lg-4 mt-4">
                                        <p class="big-artist-text mb-1">{{ bid.duration }} hr</p>
                                        <p class="main-text">Duration</p>
                                    </div>
                                    <div class="col-12 col-md-6 col-lg-4 mt-4">
                                        <p class="big-artist-text mb-1">{{ bid.venue.venue_info.capacity }}</p>
                                        <p class="main-text">Venue Capacity</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="empty-records" v-else>
                    <h3>You don't have the Cancel Bids </h3>
                </div>
            </div>
        </div>

        <div v-else class="empty-space">
            <img :src="getPhoto() + 'empty.png'" alt="empty bid" class="img-empty">
        </div>
    </div>
</template>

<script>
import {notification} from "../../helpers/notification";
import axios from "axios";
import ArtistInfo from './artist-info'

const Swal = require('sweetalert2')
export default {
    name: "index-venue",
    components: {
        ArtistInfo
    },
    data() {
        return {
            url: '/events/manage',
            bidUrl: '/event/manage',
            bidCreateUrl: '/event/manage/create',
            firstList: true,
            secondList: false,
            thirdList: false,
            newAndProceedBids: [],
            confirmedAndCompletedBids: [],
            cancelBids: [],
        }
    },
    mounted() {
        this.getNewAndProceedBids()
        this.getConfirmedAndCompletedBids()
        this.getCancelBids()
    },
    methods: {
        getNewAndProceedBids() {
            let vm = this;

            axios.get(vm.url + '/new-and-proceed-list').then(function (response) {
                vm.newAndProceedBids = response.data
            })
        },

        getConfirmedAndCompletedBids() {
            let vm = this;

            axios.get(vm.url + '/confirmed-and-completed-list').then(function (response) {
                vm.confirmedAndCompletedBids = response.data
            })
        },

        getCancelBids() {
            let vm = this;

            axios.get(vm.url + '/cancel-list').then(function (response) {
                vm.cancelBids = response.data
            })
        },

        editBid(bid) {
            Swal.fire({
                heightAuto: false,
                html:
                    'Are you sure you want to edit the bid?',
                showCancelButton: true,
                cancelButtonText: 'No',
                confirmButtonText: 'Yes',
            }).then(result => {
                if (result.value) {
                    location.href = this.bidUrl + '/' + bid.id + '/edit';
                }
            });
        },

        openBookingPage(bid) {
            window.open('/bookings/' + bid.booking_id + '/venue', '_blank');
        },

        cancelBid(bid) {
            let vm = this;
            Swal.fire({
                heightAuto: false,
                html:
                    'Are you sure you want to cancel the bid?',
                showCancelButton: true,
                cancelButtonText: 'Cancel',
                confirmButtonText: 'Confirm',
            }).then(result => {
                if (result.value) {
                    $('.js-preloader').addClass('preloader-div')
                    axios.put(vm.bidUrl + '/' + bid.id + '/cancel').then(function (response) {
                        notification('success', response.data.message);
                        let removeIndex = vm.newAndProceedBids.map(bid => bid.id).indexOf(bid.id);
                        vm.newAndProceedBids.splice(removeIndex, 1);
                        vm.getCancelBids()
                        $('.js-preloader').removeClass('preloader-div')
                    }).catch(function (error) {
                        notification('error', error.message)
                        $('.js-preloader').removeClass('preloader-div')
                    })
                }
            });
        },

        selectFirstList() {
            let vm = this;
            vm.firstList = true;
            vm.secondList = false;
            vm.thirdList = false;
        },

        selectSecondList() {
            let vm = this;
            vm.firstList = false;
            vm.secondList = true;
            vm.thirdList = false;
        },

        selectThirdList() {
            let vm = this;
            vm.firstList = false;
            vm.secondList = false;
            vm.thirdList = true;
        },

        getStatus(status) {
            let text = ''
            switch (status) {
                case 0:
                    text = 'In process';
                    break;
                case 1:
                    text = 'Ready';
                    break;
                case 2:
                    text = 'Pending artist';
                    break;
                case 3:
                    text = 'Confirmed';
                    break;
                case 4:
                    text = 'Completed';
                    break;
                case 5:
                    text = 'Canceled';
                    break;
                default:
                    text = 'Rejected';
                    break;
            }
            return text
        },

        getPhoto() {
            return '/images/user/bid/';
        },
    },
    computed: {
        sortProgressBids () {
            return this.newAndProceedBids.sort((a, b) => new Date(a.start) - new Date(b.start))
        },
        sortconfirmedAndCompletedBids () {
            return this.confirmedAndCompletedBids.sort((a, b) => new Date(a.start) - new Date(b.start))
        },
        sortcancelBids () {
            return this.cancelBids.sort((a, b) => new Date(a.start) - new Date(b.start))
        }
    }
}
</script>

<style lang="scss" scoped>
    @import '../../../sass/_variables.scss';
    .wrapper-keywords-pills::-webkit-scrollbar {
        display: none;
    }
</style>
